import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo
        title="404 - Page Not Found | VCO Group"
        description="The page you're looking for doesn't exist."
        path="/404"
        noindex
      />
      <section className="flex min-h-[60vh] flex-col items-center justify-center py-24 text-center">
        <h1 className="font-display text-6xl font-semibold text-charcoal">404</h1>
        <p className="mt-4 text-steel">This page could not be found.</p>
        <Link
          to="/"
          className="mt-8 inline-block rounded bg-brick px-7 py-3.5 font-display text-sm uppercase tracking-wide text-offwhite transition-colors hover:bg-brick-light"
        >
          Back To Home
        </Link>
      </section>
    </>
  );
}
